import { Truck, Ship, Plane, Shuffle, Warehouse } from "lucide-react";

export const CONTACT_EMAIL = "contact@kazem-logistics.com";

export const IMG = {
    hero: "/img/hero.jpg",
    road: "/img/road.jpg",
    sea: "/img/sea.jpg",
    air: "/img/air.jpg",
    port: "/img/port.jpg",
    world: "/img/world.jpg",
};

export const SERVICES = [
    {
        slug: "routier", icon: Truck, img: IMG.road,
        title: "Transport routier et affrètement", titleEn: "Road freight and chartering",
        desc: "Affrètement national et international : les meilleures capacités de transport en France, en Europe et à l'international, au meilleur coût.",
        descEn: "National and international chartering: the best transport capacity within France, across Europe and internationally, at the best cost.",
        long: "Lots complets, groupage, messagerie palettisée, tautliner, frigorifique ou ADR : grâce à notre réseau de partenaires, nous mobilisons rapidement le véhicule adapté à votre marchandise et à votre délai, et négocions pour vous le meilleur rapport qualité / prix.",
        longEn: "Full truckloads, groupage, palletised freight, tautliner, refrigerated or ADR: thanks to our partner network, we quickly secure the right vehicle for your goods and deadline, and negotiate the best value for money on your behalf.",
    },
    {
        slug: "maritime", icon: Ship, img: IMG.sea,
        title: "Transport maritime", titleEn: "Sea freight",
        desc: "Des solutions économiques pour vos volumes importants, à l'import comme à l'export.",
        descEn: "Cost-effective solutions for your large volumes, for both import and export.",
        long: "Conteneurs complets (FCL) ou groupage (LCL), pré et post-acheminement, gestion documentaire : nous organisons votre flux de port à porte.",
        longEn: "Full containers (FCL) or groupage (LCL), pre- and on-carriage, documentation: we organise your flow from port to door.",
    },
    {
        slug: "aerien", icon: Plane, img: IMG.air,
        title: "Transport aérien", titleEn: "Air freight",
        desc: "La rapidité pour vos envois urgents et de haute valeur.",
        descEn: "Speed for your urgent and high-value shipments.",
        long: "Fret aérien prioritaire ou économique, enlèvement, réservation d'espace et livraison finale pour vos marchandises sensibles au temps.",
        longEn: "Priority or economy air freight, collection, space booking and final delivery for your time-sensitive goods.",
    },
    {
        slug: "multimodal", icon: Shuffle,
        title: "Transport multimodal", titleEn: "Multimodal transport",
        desc: "La combinaison des modes de transport pour une chaîne logistique plus efficace et plus durable.",
        descEn: "Combining transport modes for a more efficient and more sustainable supply chain.",
        long: "Route, rail, mer et air : nous combinons les modes pour optimiser vos coûts, vos délais et votre empreinte carbone.",
        longEn: "Road, rail, sea and air: we combine modes to optimise your costs, lead times and carbon footprint.",
    },
    {
        slug: "logistique", icon: Warehouse,
        title: "Autres prestations logistiques", titleEn: "Other logistics services",
        desc: "Stockage, groupage, dégroupage, douane, gestion de projet logistique…",
        descEn: "Storage, consolidation, deconsolidation, customs, logistics project management…",
        long: "Entreposage, préparation, formalités douanières et accompagnement de vos projets spécifiques, de la conception au suivi.",
        longEn: "Warehousing, order preparation, customs formalities and support for your specific projects, from design to follow-up.",
    },
];
